import type { RetryPolicy } from '@/types/run';

export function formatSec(sec: number): string {
  if (sec < 1) return `${Math.round(sec * 1000)}ms`;
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return s ? `${m}m ${s}s` : `${m}m`;
}

export function formatRetry(rp: RetryPolicy): string {
  const parts: string[] = [];
  if (rp.max_attempts) parts.push(`max ${rp.max_attempts}×`);
  if (rp.initial_interval_sec) parts.push(`${formatSec(rp.initial_interval_sec)} initial`);
  if (rp.backoff_coefficient) parts.push(`×${rp.backoff_coefficient} backoff`);
  if (rp.max_interval_sec) parts.push(`cap ${formatSec(rp.max_interval_sec)}`);
  return parts.join(' · ') || '—';
}

export function stepTone(s: string): 'neutral' | 'running' | 'success' | 'failure' | 'warning' {
  switch (s) {
    case 'running':
      return 'running';
    case 'completed':
      return 'success';
    case 'failed':
    case 'timed_out':
      return 'failure';
    case 'cancelled':
      return 'warning';
    default:
      return 'neutral';
  }
}
